/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


window.updateAttributes = function updateAttributes() {
  fetch("/cart/update.js", {
    method: "POST",
    headers: {
        "Content-Type": "application/json"
    },
    body:  JSON.stringify({
        attributes: {
            "BillingGST Number": "",
            "accept_terms": "",
            "State": "",
            "gst_company": ""
        }
    })
  }).then((response) => {
    return response.json();
  }).then((response) =>  {

  }).catch((error) => {
    console.error("error: ", error)
  });
}

document.addEventListener("DOMContentLoaded", ()  => {
  window.updateAttributes();
  const isCheckout = document.querySelector(`.customer-login input[name="checkout_url"]`);
  if (isCheckout) {
    const form = document.querySelector(`.customer-login form#customer_login`);
    if (form) {
      // form.setAttribute("action", "/cart");
      isCheckout.remove();
    }
  }
});

